export * from './kyc';
export * from './auth';
export * from './p2p';
export * from './authentication';
export * from './accounting';
export * from './referral';
export * from './tiers';
export * from './financial';
export * from './profile';
export * from './mfa';
export * from './security';
export * from './ticket';

const url = new URL(window.location.href);
export const BASE_URL = `${url.protocol}//${url.hostname}`;
export const P2P_WEBSOCKET = import.meta.env.VITE_WEBSOCKET_TRADE_URL || '';
export const P2P_OPENORDERS_WEBSOCKET =
  import.meta.env.VITE_WEBSOCKET_OPENORDER_URL || '';
